import React from 'react';
import { IDuplicatedAlert, TDuplicatedEntityType } from './types';
import { useTranslation } from 'react-i18next';
import { Alert } from '@material-ui/lab';
import { IconButton } from '@material-ui/core';
import { ExternalLink } from 'react-feather';

const ENTITY_CONFIG: Record<
    TDuplicatedEntityType,
    { messageKey: string; detailPath: (id: string) => string }
> = {
    lead: {
        messageKey: 'Errors.LeadDuplicatedMessage',
        detailPath: (id) => `/management/leads/${id}`,
    },
    contact: {
        messageKey: 'Errors.ContactDuplicatedMessage',
        detailPath: (id) => `/management/contacts/${id}`,
    },
};

/**
 * Alert for duplicated lead or contact with link to the existing record.
 */
export const DuplicatedAlert = ({
    entityId,
    entityType = 'lead',
    leadId,
    showAction = true,
    ...props
}: IDuplicatedAlert) => {
    const { t } = useTranslation();
    const id = entityId ?? leadId;

    if (!id) return null;

    const config = ENTITY_CONFIG[entityType];

    const ActionButton = ({ url }: { url: string }) => (
        <IconButton
            onClick={() =>
                window.open(
                    `${window.location.origin}${url}`,
                    '_blank',
                    'noopener,noreferrer'
                )
            }
        >
            <ExternalLink />
        </IconButton>
    );

    return (
        <Alert
            severity="info"
            {...props}
            action={
                showAction ? (
                    <ActionButton url={config.detailPath(id)} />
                ) : undefined
            }
        >
            {t(config.messageKey)}
        </Alert>
    );
};
